export default "<div class=\"accordion\">\n  <ng-content></ng-content>\n</div>\n"